import { Box, IconButton, Modal } from '@mui/material';
import { AddToPhotos, Delete } from '@mui/icons-material';
import React, { useState } from 'react';
import { Col, Progress, Row } from 'antd';
import { FileUploader } from 'react-drag-drop-files';
import styled from 'styled-components';
import { closeModal } from 'utils/assets/images';
import MultiFileUploader from 'components/UI/admin/MultifileUploadGallery';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { imageUploader } from 'utils/methods/imageUploader';
import { UPLOAD_IMAGE_TO_FIREBASE } from 'utils/constants/enum';
import COLOR from 'utils/constants/color';

const fileTypes = ['JPG', 'PNG', 'GIF', 'JPEG'];

const ModalContent = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 0;
  width: 100%;
  min-width: 320px;
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  margin-bottom: 16px;
  padding: 0 4px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 20px;
  width: 100%;
  max-height: 70vh;
  overflow-y: auto;
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const SectionLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${COLOR.black300};
`;

const UploadSectionWrap = styled.div`
  width: 100%;
  position: relative;
  min-height: 140px;
`;

const ImagePreview = styled.img`
  max-width: 100%;
  max-height: 166px;
  width: auto;
  object-fit: contain;
  border-radius: 8px;
`;

const FileUploadArea = styled.div`
  height: 120px;
  width: 100%;
  border-color: #1976d2;
    background-color: #f5f5f5;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
`;

const Text = styled.div`
  font-size: 12px;
  color: #666;
  text-align: center;
  margin-top: 8px;
`;

const ImageUploaderNonNativeAdmin = ({
  imageUrl,
  openImageModal,
  handleClose,
  getUrl,
  has_delete,
}) => {
  const showAlert = useAlert();
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [isDragOver, setIsDragOver] = useState(false);

  const handleFileChange = async (file) => {
    if (!file) return;
    try {
      setLoading(true);
      setProgress(0);
      const url = await imageUploader(file, (p) => setProgress(p), UPLOAD_IMAGE_TO_FIREBASE);
      if (url) {
        getUrl(url);
      } else {
        showAlert('Unable to upload image.', 'error');
      }
    } catch (error) {
      showAlert('Unable to upload image.', 'error');
    } finally {
      setLoading(false);
      setProgress(0);
    }
  };

  return (
    <Modal open={openImageModal} onClose={handleClose} className="modelCntnt">
      <ModalContent className="modelCntntIner modalVideoPlay">
        <div className="lernModalBg">
          <div className="modelDtl">
            <HeaderRow>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {has_delete && imageUrl ? (
                  <IconButton
                    size="small"
                    style={{ backgroundColor: 'red', height: 30, width: 30 }}
                    onClick={() => {
                      getUrl(null);
                      handleClose();
                    }}
                  >
                    <Delete style={{ color: '#fff', fontSize: 18 }} />
                  </IconButton>
                ) : (
                  <span />
                )}
              </div>
              <div
                style={{ zIndex: 70, cursor: 'pointer' }}
                className="closeModelInfo"
                onClick={handleClose}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && handleClose()}
              >
                <img
                  style={{ height: '30px', display: 'block' }}
                  src={closeModal}
                  alt="close"
                />
              </div>
            </HeaderRow>
            <Body>
              {imageUrl && (
                <Section>
                  <SectionLabel>Current image</SectionLabel>
                  <ImagePreview src={imageUrl} alt="Section" />
                </Section>
              )}
              <Section>
                <SectionLabel>Select from gallery</SectionLabel>
                <MultiFileUploader inModal onSelect={(url) => getUrl(url)} />
              </Section>
              <Section>
                <SectionLabel>Or upload new image</SectionLabel>
                <UploadSectionWrap>
                  <FileUploader
                    classes="file-uploader-cover answerFileUploader"
                    handleChange={handleFileChange}
                    name="file"
                    types={fileTypes}
                    onDragEnter={() => setIsDragOver(true)}
                    onDragLeave={() => setIsDragOver(false)}
                  >
                    <FileUploadArea $isDragOver={isDragOver}>
                      {loading && (
                        <Progress
                          type="line"
                          percent={progress}
                          size="small"
                          showInfo={false}
                          style={{ width: '100%', maxWidth: 280, marginBottom: 8 }}
                        />
                      )}
                      <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Col>
                          <AddToPhotos color="primary" style={{ fontSize: 32 }} />
                        </Col>
                      </Row>
                      <Text>
                        {isDragOver ? 'Drop file here' : 'Upload or drag & drop files here'}
                      </Text>
                      <Text style={{ fontSize: 10, marginTop: 4 }}>Supported: {fileTypes.join(', ')}</Text>
                    </FileUploadArea>
                  </FileUploader>
                </UploadSectionWrap>
              </Section>
            </Body>
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default ImageUploaderNonNativeAdmin;
